export class SettingsAmenity {

    public id: number = null;
    public name: string = '';
    public timeSequenceType: string = '';
    public uses: Array<any> = [];
    public enableStatus = false;
    public allowResidentsToBook = false;
    public requiresManagerApproval = false;
    public allowEventTypeBooking = false;
    public legalAgreement: string = '';
    public legalAgreementStatus = false;
    public disclaimer: string = '';
    public disclaimerStatus = false;
    public multipleBooking = false;
    public multipleBookingMaxCount: number = null;
    public amenityImage: string = '';
    public rule: any = null;
    public bookings: Array<any> = null;
    public fees: Array<any> = null;
    public disabledDates: Array<any> = null;
    public buildingAmenity: any = [];
    public isCanEdit: boolean = true;
    public isCanDelete: boolean = true;
    public internalId: string = '';
    public template: string = '';
    public saveAsTemplate = false;
    public templateName: string = '';
    public bookingMinDay: number = null;
    public bookingMaxDay: number = null;
    public bookingMinHour: number = null;
    public bookingMaxHour: number = null;
    public limitActivityRangeValue: string = '';
    public minIntervalBetweenBooking: string = '';
    public technicalBreak: string = '';
    public limitActivityCountBookingOrDays: string = '';
    public limitActivityCountBookingOrHours: string = '';
    public limitActivityCountBooking: string = '';
    public maxTimeForAdvancedBooking: string = '';
    public minTimeForAdvancedBooking: string = '';
    public confirmationMessage: string = '';
    public staffNotificationSettings: any = null;
    public residentsNotificationSettings: any = null;
    public legalAgreementHideFromStaffInterface: boolean = false;
    public disclaimerHideFromStaffInterface: boolean = false;
    public availableWaive: boolean = false;
    public paymentAcceptCreditCards: boolean = false;
    public paymentAcceptCash: boolean = false;
    public paymentAcceptCheques: boolean = false;
    public paymentAcceptCertifiedCheque: boolean = false;
    public paymentAcceptMoneyOrder: boolean = false;
    public paymentAcceptBankDraft: boolean = false;
    public paymentAcceptCustomType: boolean = false;
    public paymentCustomTypeName: string = '';
    public defaultPaymentMethod: string = '';
    public amenityColor: string = '';
    public managementOverride: boolean = false;
    public autoApproveAfterPayment: boolean = false;
    public formFields = {
        defaultPaymentMethod: {editMode: false}
    };
    public reminders: Array<any> = [];
    public createdBy: string = '';
    public createdAt: string = '';
    public events: Array<any> = null;
    public residentOccupancyTypes: Array<any> = [];
    public userGroups: Array<any> = [];
    public customStripeAccount: string = '';
    public minutesStep: number = 5;

    checked: boolean = false; // using for table checked detection? crap

    // TODO: refactoring is needed. WTF!? Careful! piece of shit pattern used here - by filko
    static fromExistingData(amenity): SettingsAmenity {
        const settingsAmenity = new SettingsAmenity();
        if (amenity.id) settingsAmenity.id = amenity.id;
        if (amenity.internalId) settingsAmenity.internalId = amenity.internalId;
        if (amenity.createdBy) settingsAmenity.createdBy = amenity.createdBy.fullName;
        if (amenity.createdAt) settingsAmenity.createdAt = amenity.createdAt;
        if (amenity.name) settingsAmenity.name = amenity.name;
        if (amenity.timeSequenceType) settingsAmenity.timeSequenceType = amenity.timeSequenceType;
        if (amenity.uses) settingsAmenity.uses = amenity.uses;
        if (amenity.enableStatus) settingsAmenity.enableStatus = amenity.enableStatus;
        if (amenity.allowResidentsToBook) settingsAmenity.allowResidentsToBook = amenity.allowResidentsToBook;
        if (amenity.requiresManagerApproval) settingsAmenity.requiresManagerApproval = amenity.requiresManagerApproval;
        if (amenity.legalAgreement) settingsAmenity.legalAgreement = amenity.legalAgreement;
        if (amenity.legalAgreementStatus) settingsAmenity.legalAgreementStatus = amenity.legalAgreementStatus;
        if (amenity.disclaimerStatus) settingsAmenity.disclaimerStatus = amenity.disclaimerStatus;
        if (amenity.multipleBooking) settingsAmenity.multipleBooking = amenity.multipleBooking;
        if (amenity.multipleBookingMaxCount) settingsAmenity.multipleBookingMaxCount = amenity.multipleBookingMaxCount;
        if (amenity.maxTimeForAdvancedBooking) settingsAmenity.maxTimeForAdvancedBooking = amenity.maxTimeForAdvancedBooking;
        if (amenity.minTimeForAdvancedBooking) settingsAmenity.minTimeForAdvancedBooking = amenity.minTimeForAdvancedBooking;
        if (amenity.amenityImage) settingsAmenity.amenityImage = amenity.amenityImage;
        if (amenity.bookings) settingsAmenity.bookings = amenity.bookings;
        if (amenity.buildingAmenity) settingsAmenity.buildingAmenity = amenity.buildingAmenity;
        if (amenity.disabledDates) settingsAmenity.disabledDates = amenity.disabledDates;
        if (amenity.disclaimer) settingsAmenity.disclaimer = amenity.disclaimer;
        if (amenity.fees) settingsAmenity.fees = amenity.fees;
        if (amenity.reminders) settingsAmenity.reminders = amenity.reminders;
        if (amenity.confirmationMessage) settingsAmenity.confirmationMessage = amenity.confirmationMessage;
        if (amenity.customStripeAccount) settingsAmenity.customStripeAccount = amenity.customStripeAccount;
        if (amenity.staffNotificationSettings) settingsAmenity.staffNotificationSettings = amenity.staffNotificationSettings;
        if (amenity.residentsNotificationSettings) settingsAmenity.residentsNotificationSettings = amenity.residentsNotificationSettings;
        if (amenity.legalAgreementHideFromStaffInterface) settingsAmenity.legalAgreementHideFromStaffInterface = amenity.legalAgreementHideFromStaffInterface;
        if (amenity.disclaimerHideFromStaffInterface) settingsAmenity.disclaimerHideFromStaffInterface = amenity.disclaimerHideFromStaffInterface;
        if (amenity.paymentAcceptCash) settingsAmenity.paymentAcceptCash = amenity.paymentAcceptCash;
        if (amenity.paymentAcceptCheques) settingsAmenity.paymentAcceptCheques = amenity.paymentAcceptCheques;
        if (amenity.paymentAcceptCreditCards) settingsAmenity.paymentAcceptCreditCards = amenity.paymentAcceptCreditCards;
        if (amenity.paymentAcceptCertifiedCheque) settingsAmenity.paymentAcceptCertifiedCheque = amenity.paymentAcceptCertifiedCheque;
        if (amenity.paymentAcceptMoneyOrder) settingsAmenity.paymentAcceptMoneyOrder = amenity.paymentAcceptMoneyOrder;
        if (amenity.paymentAcceptBankDraft) settingsAmenity.paymentAcceptBankDraft = amenity.paymentAcceptBankDraft;
        if (amenity.paymentAcceptCustomType) settingsAmenity.paymentAcceptCustomType = amenity.paymentAcceptCustomType;
        if (amenity.paymentCustomTypeName) settingsAmenity.paymentCustomTypeName = amenity.paymentCustomTypeName;
        if (amenity.defaultPaymentMethod) settingsAmenity.defaultPaymentMethod = amenity.defaultPaymentMethod;
        if (amenity.autoApproveAfterPayment) settingsAmenity.autoApproveAfterPayment = amenity.autoApproveAfterPayment;
        if (amenity.rule) {
            settingsAmenity.rule = amenity.rule;
            if (amenity.rule.bookingMinDay) settingsAmenity.bookingMinDay = amenity.rule.bookingMinDay;
            if (amenity.rule.bookingMaxDay) settingsAmenity.bookingMaxDay = amenity.rule.bookingMaxDay;
            if (amenity.rule.bookingMinHour) settingsAmenity.bookingMinHour = amenity.rule.bookingMinHour;
            if (amenity.rule.bookingMaxHour) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
            if (amenity.rule.technicalBreak) settingsAmenity.technicalBreak = amenity.rule.technicalBreak;
            if (amenity.rule.limitActivityRangeValue) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
            if (amenity.rule.minIntervalBetweenBooking) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
            if (amenity.rule.limitActivityCountBookingOrDays) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
            if (amenity.rule.limitActivityCountBookingOrHours) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
            if (amenity.rule.limitActivityCountBooking) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
        }
        if (amenity.managementOverride) settingsAmenity.managementOverride = amenity.managementOverride;
        if (amenity.residentOccupancyTypes) settingsAmenity.residentOccupancyTypes = amenity.residentOccupancyTypes.map(o => ({
            id: o.code,
            itemName: o.name
        }));
        if (amenity.userGroups) settingsAmenity.userGroups = amenity.userGroups.map(u => ({
            id: u.bdId,
            itemName: u.name
        }));
        settingsAmenity.isCanEdit = amenity.isCanEdit;
        settingsAmenity.isCanDelete = amenity.isCanDelete;
        return settingsAmenity;
    }

    constructor() {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SettingsAmenity.ts